// ============================================================================
// Form Config: Absences
// Key: absences
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { enumFormOptions } from '../../entity-config-runtime/entity-form-config'
import { AbsenceReason, RecurrenceInterval } from '../api/backstage.schemas'
// #endregion

// #region Create Form
export const absencesCreateFormConfig: FormSection[] = [
	{
		title: 'forms_absences_create_section_main',
		fields: [
			{
				name: 'start',
				label: 'forms_absences_create_start',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'end',
				label: 'forms_absences_create_end',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'reason',
				label: 'forms_absences_create_reason',
				type: 'select' as const,
				options: enumFormOptions(AbsenceReason, 'AbsenceReason'),
				initialValue: '',
			},
			{
				name: 'recurrenceInterval',
				label: 'forms_absences_create_recurrence_interval',
				type: 'select' as const,
				options: enumFormOptions(RecurrenceInterval, 'RecurrenceInterval'),
				initialValue: '',
			},
			{
				name: 'recurrenceEnd',
				label: 'forms_absences_create_recurrence_end',
				type: 'text' as const,
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Edit Form
export const absencesEditFormConfig: FormSection[] = [
	{
		title: 'forms_absences_edit_section_main',
		fields: [
			{
				name: 'start',
				label: 'forms_absences_edit_start',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'end',
				label: 'forms_absences_edit_end',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'reason',
				label: 'forms_absences_edit_reason',
				type: 'select' as const,
				options: enumFormOptions(AbsenceReason, 'AbsenceReason'),
				initialValue: '',
			},
			{
				name: 'recurrenceInterval',
				label: 'forms_absences_edit_recurrence_interval',
				type: 'select' as const,
				options: enumFormOptions(RecurrenceInterval, 'RecurrenceInterval'),
				initialValue: '',
			},
			{
				name: 'recurrenceEnd',
				label: 'forms_absences_edit_recurrence_end',
				type: 'text' as const,
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const absencesFormsConfig = {
	create: absencesCreateFormConfig,
	edit: absencesEditFormConfig,
} as const
// #endregion
